module.exports = __webpack_public_path__ + "static/media/bonuz_logo_colorido.fac46449.svg";